import { useState } from 'react'
import { Link } from 'react-router-dom'
import { EnrollmentModal } from '../../components/EnrollmentModal'

export function NorthAmerica() {
  const [enrollmentModalOpen, setEnrollmentModalOpen] = useState(false)

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <nav className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="text-xl sm:text-2xl font-bold text-blue-600">EMR</Link>
            <div className="flex items-center space-x-4">
              <Link to="/login" className="text-gray-700 hover:text-blue-600 transition">Sign In</Link>
              <button
                onClick={() => setEnrollmentModalOpen(true)}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
              >
                Get Started
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="bg-gradient-to-br from-blue-50 via-white to-red-50 py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="text-6xl mb-6">🇺🇸</div>
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            EMR for <span className="text-blue-600">North America</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            HIPAA-compliant EMR solution designed for the United States healthcare system.
            Medicare, Medicaid, and private insurance billing integration.
          </p>
          <button
            onClick={() => setEnrollmentModalOpen(true)}
            className="bg-blue-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-700 transition"
          >
            Start Free Trial
          </button>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center mb-12">US Healthcare Features</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">💳</div>
              <h3 className="text-xl font-semibold mb-2">Insurance Billing</h3>
              <p className="text-gray-600">
                Medicare, Medicaid, and private insurance claim submission with EDI 837/835 support.
              </p>
            </div>
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">🏥</div>
              <h3 className="text-xl font-semibold mb-2">ICD-10-CM Coding</h3>
              <p className="text-gray-600">
                Full ICD-10-CM diagnosis coding with CPT procedure codes and HCPCS Level II support.
              </p>
            </div>
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">💊</div>
              <h3 className="text-xl font-semibold mb-2">EPCS Certified</h3>
              <p className="text-gray-600">
                Electronic Prescribing for Controlled Substances (EPCS) with DEA compliance.
              </p>
            </div>
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">📊</div>
              <h3 className="text-xl font-semibold mb-2">MIPS/MACRA Ready</h3>
              <p className="text-gray-600">
                Quality measure reporting for Merit-based Incentive Payment System compliance.
              </p>
            </div>
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">🔗</div>
              <h3 className="text-xl font-semibold mb-2">HIE Integration</h3>
              <p className="text-gray-600">
                Health Information Exchange connectivity for seamless data sharing across networks.
              </p>
            </div>
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">🔐</div>
              <h3 className="text-xl font-semibold mb-2">HIPAA Compliant</h3>
              <p className="text-gray-600">
                Full HIPAA compliance with encryption, audit logging, and BAA support.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Link to="/" className="text-white hover:text-blue-400 transition">← Back to Home</Link>
          <p className="mt-4 text-sm">&copy; {new Date().getFullYear()} EMR System. All rights reserved.</p>
        </div>
      </footer>

      <EnrollmentModal
        isOpen={enrollmentModalOpen}
        onClose={() => setEnrollmentModalOpen(false)}
      />
    </div>
  )
}

